import { createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";
import SuperviseWorkinghoursPanel from "@/components/supervise/supervise-workinghours-panel";

const SuperviseWorkingHoursPage = (): JSX.Element => <SuperviseWorkinghoursPanel />;

export const Route = createFileRoute("/_app/supervise/workinghours/")({
	component: SuperviseWorkingHoursPage,
});
